import React from "react";
import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import { useSendbird } from "@/hooks/useSendbird";

/**
 * SendbirdNotificationBell — nav icon that links to /chat with the unread badge.
 *
 * Hidden when Sendbird isn't configured or the user isn't authenticated.
 */
const SendbirdNotificationBell = ({ className = "" }) => {
    const { ready, unreadCount } = useSendbird();
    if (!ready) return null;
    const badge = unreadCount > 99 ? "99+" : String(unreadCount);
    return (
        <Link
            to="/chat"
            className={`relative inline-flex items-center justify-center rounded-full p-2 text-slate-600 hover:bg-slate-100 hover:text-brand-700 dark:text-zinc-300 dark:hover:bg-white/[0.06] ${className}`}
            aria-label="Open notifications and chat"
            data-testid="sendbird-notification-bell"
        >
            <Bell className="h-5 w-5" />
            {unreadCount > 0 && (
                <span
                    className="absolute -right-0.5 -top-0.5 inline-flex min-w-[18px] items-center justify-center rounded-full bg-rose-500 px-1 text-[10px] font-semibold text-white shadow-sm ring-2 ring-white dark:ring-zinc-900"
                    data-testid="sendbird-notification-unread-count"
                >
                    {badge}
                </span>
            )}
        </Link>
    );
};

export default SendbirdNotificationBell;
